var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"heading text-center no-margin"},[_vm._v(_vm._s(_vm.deviceName))]),_c('h4',{staticClass:"text-muted"},[_vm._v("\n    "+_vm._s(_vm.$t('message.spots.message.supportConnection'))+"\n  ")]),_c('app-connection-support-section',{attrs:{"config":_vm.config}}),_c('div',{staticClass:"segment"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }